import React, { useState, useEffect } from 'react';
import { getHistory, clearHistory, AscendantHistoryEntry } from '../utils/localStorage';
import { COUNTIES } from '../constants/constants';

interface HistoryProps {
    onSelectEntry?: (entry: AscendantHistoryEntry) => void;
    refreshTrigger?: number;
}

const History: React.FC<HistoryProps> = ({ onSelectEntry, refreshTrigger }) => {
    const [history, setHistory] = useState<AscendantHistoryEntry[]>([]);

    useEffect(() => {
        loadHistory();
    }, [refreshTrigger]);

    const loadHistory = () => {
        const savedHistory = getHistory();
        setHistory(savedHistory);
    };

    const handleClear = () => {
        if (window.confirm('Möchten Sie wirklich den gesamten Verlauf löschen?')) {
            clearHistory();
            setHistory([]);
        }
    };

    const formatDate = (timestamp: string) => {
        const date = new Date(timestamp);
        return date.toLocaleString('de-DE', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const getCountyName = (id: number) => {
        const county = COUNTIES.find(c => c.id === id);
        return county?.name || 'Unbekannt';
    };

    if (history.length === 0) {
        return (
            <div className="card bg-light bg-opacity-10 border-0 mt-4">
                <div className="card-body text-center">
                    <h5 className="card-title">Verlauf</h5>
                    <p className="text-muted mb-0">Noch keine Berechnungen gespeichert.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="card bg-light bg-opacity-10 border-0 mt-4">
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="card-title mb-0">Dein Verlauf</h5>
                    <button className="btn btn-sm btn-danger text-white" onClick={handleClear}>
                        Verlauf löschen
                    </button>
                </div>
                <div className="d-flex flex-column gap-3">
                    {history.map((entry, index) => (
                        <div key={index} className="card bg-dark bg-opacity-25 border border-light border-opacity-25">
                            <div className="card-body">
                                <div className="text-muted small mb-2">{formatDate(entry.timestamp)}</div>
                                <div className="mb-2">
                                    <strong>Geburtsdatum:</strong> {entry.birthdate}<br />
                                    <strong>Geburtszeit:</strong> {entry.birthtime}<br />
                                    <strong>Geburtsort:</strong> {getCountyName(entry.birthlocation)}<br />
                                    <strong>Aszendent:</strong> {entry.ascendant}
                                </div>
                                {onSelectEntry && (
                                    <button
                                        className="btn btn-sm btn-outline-primary"
                                        onClick={() => onSelectEntry(entry)}
                                    >
                                        Verwenden
                                    </button>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default History;

